import React from 'react'
import {useTranslation} from 'react-i18next'

import {Stack, StackProps} from '@mui/material'
import {PGTheme, PGTypography} from '@progynyglobal/pg-ui-library'

export const SUPPORT_EMAIL = 'support@progynyglobal.com'

type ContactSupportProps = StackProps & {
  textKey: string
}

const ContactSupport: React.FC<ContactSupportProps> = ({
  textKey,
  ...stackProps
}) => {
  const {t} = useTranslation()
  return (
    <Stack flexDirection='row' {...stackProps}>
      <PGTypography variant='subheader'>{t(textKey)}</PGTypography>
      &nbsp;
      <PGTypography
        variant='subheader'
        color={PGTheme.productLines.fertility.primary}
      >
        {SUPPORT_EMAIL}
      </PGTypography>
    </Stack>
  )
}

export default ContactSupport
